
import MyModal from "components/MyModal";
import React from "react";
import Button from "../button/Button";
import { AlertDialogActions, AlertDialogButton, AlertDialogDescription, AlertDialogModal, AlertDialogTitle } from "./Theme";

const AlertDialog = ({
  title = "Are you sure?",
  description,
  open,
  onDecline,
  onAccept,
  disabled = false,
  acceptBtnText = "Confirm",
  fullWidth = false, 
 PaperProps={},
   useFlex = true,
}) => {
console.log('value of useFlex',useFlex)
  if (!open) return null;
  

  return (
    <MyModal
      className="main__alert-dialog"
      open={open}
      onClose={onDecline}
      PaperProps={PaperProps}
      fullWidth = {fullWidth}
        useFlex ={useFlex}
    >
      <AlertDialogModal>
        <AlertDialogTitle>{title}</AlertDialogTitle>
        {description && <AlertDialogDescription>{description}</AlertDialogDescription>}
        {/* {description && (
          <AlertDialogDescription>
            {description.split("\n").map((line, index) => (
              <React.Fragment key={index}>
                {line}
                {index < description.split("\n").length - 1 && <br />}
              </React.Fragment>
            ))}
          </AlertDialogDescription>
        )} */}
        <AlertDialogActions>
          <Button
            onClick={onDecline}
            variant="primary-outline"
            size="md"
          >
            <span>Cancel</span>
          </Button>
          <Button
            onClick={onAccept}
            variant="primary"
            size="md"
            disabled={disabled}
          >
            <span>{acceptBtnText}</span>
          </Button>

        </AlertDialogActions>
      </AlertDialogModal>
    </MyModal>
  )
}

export default AlertDialog;